import { GroupSecurity } from '@quromedical/fhir-common';
import { Row } from 'components/base';
import * as Card from 'components/card';
import { LinkButton } from 'components/input';
import { WithGroup } from 'core/auth';
import React from 'react';

interface PatientServiceRequestActionsCardProps {
  patientId: string;
}

export const PatientServiceRequestActionsCard: React.FC<PatientServiceRequestActionsCardProps> = ({
  patientId,
}) => (
  <Card.BaseWrapper>
    <Row>
      <WithGroup groups={[GroupSecurity.ServiceRequestCreate]}>
        <LinkButton
          text="Create Ampath Request"
          to={{
            screen: 'Patient',
            params: {
              screen: 'View',
              params: { id: patientId, screen: 'CreateAmpathServiceRequest' },
            },
          }}
        />
      </WithGroup>
      <WithGroup groups={[GroupSecurity.ServiceRequestRead]}>
        <LinkButton
          text="View All"
          to={{
            screen: 'Patient',
            params: {
              screen: 'View',
              params: {
                id: patientId,
                screen: 'ServiceRequests',
                params: {
                  screen: 'List',
                },
              },
            },
          }}
        />
      </WithGroup>
    </Row>
  </Card.BaseWrapper>
);
